import type { Middleware } from '@arcubase/client-ts'
import { getCurrentKioskGroup } from '@/utils/kioskGroup'

// Kiosk环境中间件
export const kioskMiddleware: Middleware = async (context, next) => {
  const { config, store } = context
  
  // === REQUEST 阶段 (next() 之前) ===
  // 添加 Kiosk seat 信息
  if (store?.kiosk?.groups) {
    const groupId = getCurrentKioskGroup()
    if (groupId) {
      const stationInfo = store.kiosk.groups[groupId]
      if (stationInfo?.registered && stationInfo.station_name) {
        config.headers = config.headers || {}
        config.headers['X-Kiosk-Seat'] = stationInfo.station_name
      }
    }
  }
  
  const result = await next()
  
  // === RESPONSE 阶段 (next() 之后) ===
  // 可以在这里添加 Kiosk 特定的响应处理逻辑
  
  return result
}
